import { cn } from "@/lib/utils";
import {
  ColumnDefTemplate,
  flexRender,
  Header,
  HeaderContext,
} from "@tanstack/react-table";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface DataTableColumnNameProps<TData> {
  header: Header<TData, unknown>;
  className?: string;
}
export default function DataTableColumnName<TData>({
  header,
  className,
  ...props
}: DataTableColumnNameProps<TData>) {
  const { t } = useTranslation();

  const renderHeaderContent = useCallback(
    (
      header?:
        | ColumnDefTemplate<HeaderContext<TData, unknown>>
        | string
        | undefined,
    ) => {
      if (typeof header === "string") {
        return t(header);
      }
      return header;
    },
    [t],
  );

  const content = renderHeaderContent(header.column.columnDef.header);
  const title = typeof content === "string" ? content : undefined;

  const defaultClassName =
    "truncate w-full cursor-default rounded-md p-1 select-none";

  if (content === "") {
    return null;
  }

  // TODO: Replace title with tooltip?
  return (
    <span className={cn(defaultClassName, className)} title={title} {...props}>
      {header.isPlaceholder ? null : flexRender(content, header.getContext())}
    </span>
  );
}
